/**
 * Top merchants by card spend volume.
 *
 * Computed from the replay feed, same as corridors. Shows the brands
 * African users are paying with their Eversend cards — the "building
 * businesses and accessing the digital economy" narrative.
 */

export type MerchantStat = {
  name: string;
  count: number;
  volumeUsd: number;
};

export function TopMerchants({
  merchants,
}: {
  merchants: MerchantStat[];
}) {
  if (!merchants.length) return null;
  return (
    <div className="top-merchants">
      <div className="merchants-label">TOP MERCHANTS · TODAY</div>
      <ul>
        {merchants.map((m) => (
          <li key={m.name}>
            <span className="merchant-name">{m.name}</span>
            <span className="merchant-vol">${formatAmount(m.volumeUsd)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function formatAmount(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(2) + "M";
  if (n >= 1000) return (n / 1000).toFixed(1) + "K";
  return Math.round(n).toLocaleString("en-US");
}
